import { HubCameraType } from '@robovision/hub'
import { i18n } from '~i18n'
import {
  CameraType,
  EmulatorCameraType,
} from './CameraType'


export interface CameraTypeOption {
  description: string
  extension?: string
  serialNumber?: {
    hint: string,
    regex: RegExp,
    validationMessage: string,
  },
  title: string
  tool?: string
  value: CameraType
}

export const cameraTypes: CameraTypeOption[] = [
  {
    get description () {
      return i18n.t('cameras.types.baslerDescription')
    },
    extension: '.pfs',
    serialNumber: {
      get hint () {
        return i18n.t('cameras.fields.serialNumberHint.basler')
      },
      regex: /^(\d{8}|0815-000\d)$/,
      get validationMessage () {
        return i18n.t('cameras.validation.serialNumberBasler')
      },
    },
    get title () {
      return i18n.t('cameras.types.basler')
    },
    tool: 'Basler Pylon viewer',
    value: HubCameraType.BASLER,
  },
  {
    get description () {
      return i18n.t('cameras.types.genicamDescription')
    },
    extension: '.pvcfg',
    serialNumber: {
      get hint () {
        return i18n.t('cameras.fields.serialNumberHint.genicam')
      },
      regex: /^[a-zA-Z0-9_\-.@]{1,255}$/,
      get validationMessage () {
        return i18n.t('cameras.validation.serialNumberGenicam')
      },
    },
    get title () {
      return i18n.t('cameras.types.genicam')
    },
    value: HubCameraType.GENICAM,
  },
  {
    get description () {
      return i18n.t('cameras.types.emulatorDescription')
    },
    get title () {
      return i18n.t('cameras.types.emulator')
    },
    value: EmulatorCameraType.EMULATOR,
  },
  // {
  //   get description () {
  //     return i18n.t('cameras.types.alliedVisionDescription')
  //   },
  //   extension: '.xml',
  //   serialFormat: '12-3456789012',
  //   serialRegex: /^\d{2}-\d{10}$/,
  //   get title () {
  //     return i18n.t('cameras.types.alliedVision')
  //   },
  //   tool: 'Allied Vision Vimba',
  //   value: HubCameraType.ALLIED_VISION,
  // },
]
